<template lang="pug">
    #filtrar-relatorio-rastreabilidade
        .filtrar-relatorio-rastreabilidade-container
            .filtrar-relatorio-rastreabilidade-input-container
                .filtrar-relatorio-rastreabilidade__input
                    i.el-icon-search
                    input(
                        v-model='pesquisa',
                        type='text',
                        :placeholder="$t('mensagens.relatorioRastreabilidade.filtro.pesquisaInteligente')",
                        autocomplete='off',
                        @keyup.enter='pesquisar',
                        @blur='fecharLista'
                    )

                .filtrar-relatorio-rastreabilidade__resultado
                    transition(name='el-zoom-in-top')
                        ul.filtrar-relatorio-rastreabilidade__ul(
                            v-show='mostrarResultado && resultadosPesquisa.length > 0'
                        )
                            li(v-for='resultado in resultadosPesquisa', :key='resultado.id', @click='selecionarResultado(resultado)')
                                span {{ resultado.reportNumber }}

            .filtrar-relatorio-rastreabilidade__button
                el-popover(
                    placement='bottom-start',
                    width='750',
                    trigger='click',
                    popper-class='el-popover-relatorio-rastreabilidade'
                    v-model="popoverVisible"
                )
                    BaseButton.button-outline(
                        type='outline',
                        icon='lyra-icon lyra-filtro',
                        name='filtro',
                        :plain='true',
                        slot='reference'
                    ) {{ $t('mensagens.blocoFiltros.uteis.filtrosAvancados') }}

                    el-form.filtro(label-position='top')
                        .filtrar-relatorio-rastreabilidade-popover-header
                            .filtrar-relatorio-rastreabilidade-popover-header__text {{ $t('mensagens.blocoFiltros.uteis.filtrosAvancados') }}
                            .filtrar-relatorio-rastreabilidade-popover-header__link(
                                @click='aplicar'
                            )
                                | {{ $t('mensagens.blocoFiltros.uteis.aplicarFiltros') }}

                        .filtrar-relatorio-rastreabilidade-popover-collapse
                            el-form-item.mb-0.filtro-accordion
                                el-collapse(
                                    accordion
                                )
                                    el-collapse-item(
                                        :title='$t("mensagens.relatorioRastreabilidade.filtro.rangeDatas")',
                                        name='rangeDatas'
                                    )
                                        .el-collapse-restricoes--loading
                                            el-date-picker(
                                                v-model='filter.initialreportDate',
                                                class='mr-2'
                                                type='date',
                                                :placeholder="$t('mensagens.relatorioRastreabilidade.filtro.rangeDatasInicial')",
                                                format='dd/MM/yyyy'
                                            )

                                            el-date-picker(
                                                v-model='filter.finalReportDate',
                                                type='date',
                                                :placeholder="$t('mensagens.relatorioRastreabilidade.filtro.rangeDatasFinal')",
                                                format='dd/MM/yyyy'
                                            )

                                    el-collapse-item(
                                        :title='$t("mensagens.relatorioRastreabilidade.filtro.rangeVolume")',
                                        name='rangeVolume'
                                    )
                                        .el-collapse-restricoes--loading.d-flex
                                            el-input(
                                                v-model='filter.minReportVolume',
                                                class="mr-2"
                                                :placeholder='$t("mensagens.relatorioRastreabilidade.filtro.rangeVolumeInicial")',
                                                type='number'
                                            )

                                            el-input(
                                                v-model='filter.maxReportVolume',
                                                :placeholder='$t("mensagens.relatorioRastreabilidade.filtro.rangeVolumeFinal")',
                                                type='number'
                                            )

                                    el-collapse-item(
                                        :title='$t("mensagens.relatorioRastreabilidade.filtro.status")',
                                        name='status'
                                    )
                                        .el-collapse-restricoes--loading
                                            el-select(
                                                v-model="filter.status"
                                                multiple
                                                placeholder="Selecione o status"
                                                class="el-collapse-restricoes--loading"
                                            )
                                                el-option(
                                                    v-for="status in statusOptionsTraduzidos"
                                                    :key="status.codigo"
                                                    :label="status.descricao"
                                                    :value="status.codigo"
                                                )

        .filtrar-relatorio-rastreabilidade-filtro-selecionado
            span.filtrar-relatorio-rastreabilidade-filtro-selecionado__titulo {{ $t('mensagens.blocoFiltros.uteis.filtrosSelecionados') }}
            el-tag.filtrar-relatorio-rastreabilidade-filtro-selecionado__tag(
                v-for='tag in tags',
                :key='tag.nome',
                closable='',
                type='success',
                @close='removerFiltro(tag)'
            )
                span {{ getNome(tag.valor) }}

            el-tag.filtrar-relatorio-rastreabilidade-filtro-selecionado__limpar(
                v-if='tags.length',
                type='info',
                @click='limparFiltros'
            ) {{ $t('mensagens.blocoFiltros.uteis.limparFiltro') }}
                i.el-icon-delete

            span.filtrar-relatorio-rastreabilidade-filtro-selecionado__nenhum(
                v-else
            ) {{ $t('mensagens.blocoFiltros.uteis.nenhumFiltroSelecionado') }}
</template>
<script>
import BaseButton from '@/components/vegaComponents/BaseButton.vue';
import { statusTraceabilityReport } from '@/modules/traceability-report/utils';
import RelatorioRastreabilidadeService from '@/services/RelatorioRastreabilidadeService';
import EventBus from '@/utils/eventBus';
export default {
    name: 'FiltrarRelatorioRastreabilidade',
    emits: ['remover-tag'],
    components: {
        BaseButton
    },
    props: {
        isLoading: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            pesquisa: '',
            mostrarResultado: false,
            resultadosPesquisa: [],
            filter: {
                initialreportDate: '',
                finalReportDate: '',
                minReportVolume: '',
                maxReportVolume: '',
                status: [],
                reportNumber: ''
            },
            statusOptions: Object.values(statusTraceabilityReport),
            tagsBase: [],
            popoverVisible: false
        };
    },
    computed: {
        statusOptionsTraduzidos() {
            return this.statusOptions.map(status => ({
                codigo: status.codigo,
                descricao: this.translate(status.codigo)
            }));
        },
        tags() {
            return this.tagsBase.map(tag => {
                if (tag.nome === 'Status') {
                    return {
                        ...tag,
                        valor: tag.valor
                            .split(', ')
                            .map(status => this.translate(status))
                            .join(', ')
                    };
                }
                return tag;
            });
        }
    },
    methods: {
        async pesquisar() {
            if (!this.pesquisa) {
                this.mostrarResultado = false;
                return;
            }

            try {
                const filter = {
                    ...this.filter,
                    page: 0,
                    size: 10,
                    reportNumber: this.pesquisa
                };

                const response = await RelatorioRastreabilidadeService.filterTraceabilityReport(filter);
                this.resultadosPesquisa = response.data.content;

                this.mostrarResultado = this.resultadosPesquisa.length > 0;
            } catch (error) {
                this.$notify.error({
                    message: this.$t('mensagens.relatorioRastreabilidade.filtro.searchError')
                });
            }
        },
        selecionarResultado(resultado) {
            if (resultado.reportNumber === this.filter.reportNumber) {
                this.mostrarResultado = false;
                return;
            }
            this.tags.push({
                nome: 'Number',
                valor: resultado.reportNumber
            });

            this.filter.reportNumber = resultado.reportNumber;
            this.pesquisa = resultado.reportNumber;
            this.mostrarResultado = false;

            const resultadoArray = [resultado];
            EventBus.$emit('update-filter', this.filter);
            EventBus.$emit('filtered-reports-reportNumber', resultadoArray);
        },
        fecharLista() {
            setTimeout(() => {
                this.mostrarResultado = false;
            }, 300);
        },
        formatarData(date) {
            if (!date) return '';
            const data = new Date(date);
            const ano = data.getFullYear();
            const mes = String(data.getMonth() + 1).padStart(2, '0');
            const dia = String(data.getDate()).padStart(2, '0');
            return `${ano}-${mes}-${dia}`;
        },

        async aplicar() {
            if ((this.filter.initialreportDate && !this.filter.finalReportDate) ||
                (!this.filter.initialreportDate && this.filter.finalReportDate)) {
                this.$notify.error({
                    message: this.$t('mensagens.relatorioRastreabilidade.filtro.rangeDatasError')
                });
                return;
            }

            if ((this.filter.minReportVolume && !this.filter.maxReportVolume) ||
                (!this.filter.minReportVolume && this.filter.maxReportVolume)) {
                this.$notify.error({
                    message: this.$t('mensagens.relatorioRastreabilidade.filtro.rangeVolumeError')
                });
                return;
            }

            this.tagsBase = [];

            if (this.filter.initialreportDate && this.filter.finalReportDate) {
                this.tagsBase.push({
                    nome: 'Datas',
                    valor: `${this.formatarData(this.filter.initialreportDate)} - ${this.formatarData(this.filter.finalReportDate)}`
                });
            }

            if (this.filter.minReportVolume && this.filter.maxReportVolume) {
                this.tagsBase.push({
                    nome: 'Volume',
                    valor: `${this.filter.minReportVolume} - ${this.filter.maxReportVolume}`
                });
            }

            if (this.filter.status.length > 0) {
                const statusConcatenados = this.filter.status.join(', ');
                this.tagsBase.push({
                    nome: 'Status',
                    valor: statusConcatenados
                });
            }

            if (this.filter.reportNumber) {
                this.tagsBase.push({
                    nome: 'Number',
                    valor: this.filter.reportNumber
                });
            }

            const filter = {
                ...this.filter,
                initialreportDate: this.formatarData(this.filter.initialreportDate),
                finalReportDate: this.formatarData(this.filter.finalReportDate),
                status: this.filter.status.join(',')
            };

            EventBus.$emit('update-filter', filter);
            this.popoverVisible = false;
        },
        limpar() {
            this.mostrarResultado = false;
        },
        removerFiltro(tag) {
            const index = this.tagsBase.indexOf(tag);
            if (index > -1) {
                this.tagsBase.splice(index, 1);
            }

            if (tag.nome === 'Datas') {
                this.filter.initialreportDate = '';
                this.filter.finalReportDate = '';
            } else if (tag.nome === 'Volume') {
                this.filter.minReportVolume = null;
                this.filter.maxReportVolume = null;
            } else if (tag.nome === 'Status') {
                this.filter.status = [];
            } else if (tag.nome === 'Number') {
                if (this.tagsBase.every(t => t.nome !== 'Number')) {
                    this.filter.reportNumber = '';
                }
            }

            this.aplicar();
        },

        limparFiltros() {
            this.filter.initialreportDate = '';
            this.filter.finalReportDate = '';
            this.filter.minReportVolume = null;
            this.filter.maxReportVolume = null;
            this.filter.status = [];
            this.filter.reportNumber = '';
            this.tags = [];

            this.aplicar();
        },

        getNome(valor) {
            return `${valor}`;
        },

        translate(key) {
            const chaveNormalizada = this.formatadorDeTexto(key);
            return this.$t(`mensagens.relatorioRastreabilidade.tabelaListagem.statusTag.${chaveNormalizada}`);
        },

        formatadorDeTexto(texto) {
            return texto
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .replace(/[\s_]+/g, '-')
                .toUpperCase();
        }
    }
};
</script>
<style lang="scss" scoped>
.filtrar-relatorio-rastreabilidade-container {
    display: flex;
    justify-content: space-between;
}

.filtrar-relatorio-rastreabilidade-input-container {
    width: 100%;
    height: 42px;
    border-radius: 5px;
    background: var(--white);
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    position: relative;
    margin-right: 10px;
}

.filtrar-relatorio-rastreabilidade__resultado {
    position: absolute;
    width: 100%;
}

.filtrar-relatorio-rastreabilidade__resultado__nome {
    margin: 0 10px;
}

.filtrar-relatorio-rastreabilidade__input {
    height: 100%;
    display: flex;
    justify-content: center;

    i.el-icon-search {
        color: var(--primary);
        font-size: 25px;
        font-weight: bold;
        display: flex;
        align-items: center;
        margin: 0 8px;
    }

    input {
        width: 100%;
        height: 100%;
        border: none;
        outline: none;
        border-radius: 5px;
        color: var(--primary);
    }
}

.filtrar-relatorio-rastreabilidade__ul {
    list-style: none;
    padding: 8px 0 8px 24px;
    position: relative;
    z-index: 42;
    margin-top: 5px;
    border-radius: 5px;
    background-color: var(--white);
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);

    li {
        padding-left: 18px;
        margin-top: 5px;
        cursor: pointer;
    }
}

.filtrar-relatorio-rastreabilidade-filtro-selecionado {
    margin-top: 15px;
    min-height: 42px;

    .filtrar-relatorio-rastreabilidade-filtro-selecionado__limpar {
        cursor: pointer;
    }
}

.filtrar-relatorio-rastreabilidade-filtro-selecionado__titulo {
    font-size: 18px;
    font-weight: 100;
}

.filtrar-relatorio-rastreabilidade-filtro-selecionado__tag {
    margin: 0 5px 10px 5px;
}

.filtrar-relatorio-rastreabilidade-filtro-selecionado__nenhum {
    margin-left: 5px;
    font-weight: 100;
    font-style: italic;
    font-size: 14px;
}

.filtrar-relatorio-rastreabilidade-popover-header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;

    .filtrar-relatorio-rastreabilidade-popover-header__text {
        color: var(--primary);
        font-weight: 600;
    }

    .filtrar-relatorio-rastreabilidade-popover-header__link {
        color: #1989fa;
        text-decoration: underline;
        cursor: pointer;
    }
}

.filtrar-relatorio-rastreabilidade-popover-collapse {
    .el-select {
        width: 100%;
    }

    .el-collapse-item__header {
        font-weight: 500;
    }

    .filtro-accordion {
        margin-top: 10px;
    }

    .el-checkbox {
        margin-right: 12px !important;
        min-width: 200px;
    }

    .el-checkbox-group {
        display: flex;
        flex-wrap: wrap;
    }
}

.filtrar-relatorio-rastreabilidade-popover-collapse__select {
    display: flex;
    justify-content: space-between;
}
.filtrar-relatorio-rastreabilidade-popover-header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;

    .filtrar-relatorio-rastreabilidade-popover-header__text {
        color: var(--primary);
        font-weight: 600;
        font-size: 16px;
        line-height: 14px;
    }

    .filtrar-relatorio-rastreabilidade-popover-header__link {
        color: #1989fa;
        font-weight: 500;
        text-decoration: underline;
        cursor: pointer;
        font-size: 16px;
        line-height: 14px;
    }
}

.filtrar-relatorio-rastreabilidade-popover-collapse {
    .el-select {
        width: 100%;
    }

    .el-collapse-item div p {
        font-size: 14px;
        margin-bottom: 0.5rem;
        font-weight: 500;
    }

    .el-collapse-item__header {
        font-weight: 500;
    }

    .filtro-accordion {
        margin-top: 10px;
    }

    .el-checkbox,
    .el-radio {
        margin-right: 12px !important;
        min-width: 200px;
        line-height: 2;
    }

    .el-radio {
        color: var(--primary);
        font-weight: 500;
        line-height: 16px;
    }
}

.filtrar-relatorio-rastreabilidade-popover-collapse__select {
    display: flex;
    justify-content: start;
    gap: 25px;
    min-height: 60px;
}

.button-outline {
    border-color: var(--primary) !important;
    color: var(--primary) !important;
    background: transparent !important;
    display: flex;
    align-items: center;

    .lyra-filtro:before {
        content: '';
        width: 15px !important;
        height: 12px !important;
        background-color: var(--primary) !important;
        margin-right: 6px;
    }
}

.el-collapse-restricoes--loading {
    min-height: 40px;
}

.el-tag {
    border-radius: 20px !important;
}

.el-tag.el-tag--success {
    border-color: var(--secondary-two) !important;
    color: var(--white) !important;
    background: var(--secondary-two) !important;
}
</style>
